import React from 'react';
import Logos from '@/components/logo';
import { getSite } from '@/common/constants/platform-constants';
import s from './index.module.less';
import { SiteNavHelps } from './methods';

const Header = () => (
  <div className={s.headerCon}>
    <Logos />
    {SiteNavHelps[getSite()]}
  </div>
);

export default Header;
